import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import {
  authenticated,
  authenticatedFailed,
  refreshTokenAction,
  refreshTokenDispatched,
  refreshTokenSuccessAction,
} from "../actions/Auth";
import {
  SIGNIN,
  REFRESH_TOKEN,
  REFRESH_TOKEN_FAILURE,
  SIGNOUT,
  SIGNOUT_SUCCESS,
} from "../constants/Auth";
import JwtAuthService from "services/JwtAuthService";
import { API_BASE_URL } from "configs/AppConfig";
import axios from "axios";
import { API_REFRESH_TOKEN } from "constants/ApiConstant";

const refreshTokenAPI = async (refreshToken, token) => {
  try {
    const headers = {
      Authorization: `bearer ${token}`,
    };
    var result = await axios.post(
      `${API_BASE_URL}/${API_REFRESH_TOKEN}?token=${refreshToken}`,
      null,
      {
        headers: headers,
      }
    );

    return result;
  } catch (error) {}
};

export function* signOut() {
  try {
    yield call(JwtAuthService.logout);
  } catch (error) {
    // yield put({ type: SIGNOUT_SUCCESS });
  }
  yield put({ type: SIGNOUT_SUCCESS });
}

export function* signIn(action) {
  const { personalKey, password } = action.payload;

  try {
    const user = yield call(JwtAuthService.login, personalKey, password);
    if (user && user.state) {
      const {
        accessToken,
        refreshToken,
        roles,
        permissions,
        refreshTokenExpiration,
      } = user.data;

      localStorage.setItem("dontShowAgain", "false");

      yield put(
        authenticated(
          accessToken,
          refreshToken,
          roles,
          permissions,
          refreshTokenExpiration
        )
      );

      yield delay(300000);

      yield put(refreshTokenAction(refreshToken)); // Call refreshToken after successful login
    } else {
      yield put(authenticatedFailed());
      return;
    }
  } catch (err) {
    yield put(authenticatedFailed());
    return;
  }
}

function* refreshTokenSaga() {
  try {
    const refreshToken = yield select((state) => state.auth.refreshToken);
    const token = yield select((state) => state.auth.token);
    var valid =
      token &&
      refreshToken &&
      token !== undefined &&
      refreshToken !== undefined;
    if (valid) {
      const response = yield call(refreshTokenAPI, refreshToken, token);
      if (response?.data.state) {
        yield put(refreshTokenSuccessAction(response.data.data));
        yield put(refreshTokenDispatched());
        yield delay(300000);
        yield put(refreshTokenAction(refreshToken));
      } else {
        yield put({ type: REFRESH_TOKEN_FAILURE, error: "Failure" });
      }
    }
  } catch (error) {
    yield put({ type: REFRESH_TOKEN_FAILURE, error: error.message });
  }
}

export default function* rootSaga() {
  yield takeLatest(SIGNIN, signIn);
  yield takeLatest(SIGNOUT, signOut);
  yield takeLatest(REFRESH_TOKEN, refreshTokenSaga);
}
